import RTE from '../globals/RTE';

export default function pageTemplates() {
  // Do nothing if we're not on a page template
  if (
    !document.body.classList.contains('page-template-page')
    && !document.body.classList.contains('page-template-page.contact')
  ) {
    return;
  }

  const el = document.querySelector('.page');

  new RTE(el.querySelector('.rte'));
}
